export default __webpack_public_path__ + "static/media/ic-board.bdff7977.svg";